export default __webpack_public_path__ + "static/media/8H.878dbca5.svg";